var mm_dataone_config = {
  "owner_id": 206,
  "forms": [ /* array of forms */
    {
      "form_type": 'contact',
      "form_id": '#pfg-form-3',
      "term_id": '716075d9-4b93-4c07-b2c6-ca2fb1c6675e',
      "classes_add": [
        ['[name="nome"]', 'mm-prv-name'],
          ['[name="cognome"]', 'mm-prv-surname'],
          ['[name="email"]', 'mm-prv-email'],
          ['[name="telefono"]', 'mm-prv-telephone']
      ],
      "submit": '[type="submit"]',
      "el_to_remove": [],
      "el_to_wrap": [],
      "wrapper_insert_before": '.justify-content-end',
      "el_to_hide": [],
      "submit_attributes": ['name']
    },
    {
      "form_type": 'job',
      "form_id": '#pfg-form-4',
      "term_id": '716075d9-4b93-4c07-b2c6-ca2fb1c6675e',
      "classes_add": [
        ['[name="nome"]', 'mm-prv-name'],
          ['[name="cognome"]', 'mm-prv-surname'],
          ['[name="email"]', 'mm-prv-email'],
          ['[name="telefono"]', 'mm-prv-telephone']
      ],
      "submit": '[type="submit"]',
      "el_to_remove": [],
      "el_to_wrap": [],
      "wrapper_insert_before": '.justify-content-end',
      "el_to_hide": [],
      "submit_attributes": ['name']
    },
    {
      "form_type": 'preventivo',
      "form_id": '#pfg-form-5',
      "term_id": '716075d9-4b93-4c07-b2c6-ca2fb1c6675e',
      "classes_add": [
        ['[name="nome"]', 'mm-prv-name'],
        ['[name="cognome"]', 'mm-prv-surname'],
        ['[name="email"]', 'mm-prv-email'],
        ['[name="telefono"]', 'mm-prv-telephone']
      ],
      "submit": '[type="submit"]',
      "el_to_remove": [],
      "el_to_wrap": [],
      "wrapper_insert_before": '.justify-content-end',
      "el_to_hide": [],
      "submit_attributes": ['name']
    },
    {
      "form_type": 'newsletter',
      "form_id": '#pfg-form-2',
      "term_id": '5522a307-517c-435b-92a5-7d34c2743553',
      "classes_add": [
        ['[name="nome"]', 'mm-prv-name'],
        ['[name="cognome"]', 'mm-prv-surname'],
        ['[name="email"]', 'mm-prv-email']
      ],
      "submit": '[type="submit"]',
      "el_to_remove": [],
      "el_to_wrap": [],
      "wrapper_insert_before": '.justify-content-end',
      "submit_attributes": ['name']
    },
    {
        "form_type": 'progetta',
        "form_id": '#pfg-form-1',
        "term_id": '716075d9-4b93-4c07-b2c6-ca2fb1c6675e',
        "classes_add": [
          ['[name="nome"]', 'mm-prv-name'],
          ['[name="cognome"]', 'mm-prv-surname'],
          ['[name="email"]', 'mm-prv-email'],
          ['[name="telefono"]', 'mm-prv-telephone']
        ],
        "submit": '[type="submit"]',
        "el_to_remove": [],
        "el_to_wrap": [],
        "wrapper_insert_before": '.justify-content-end',
        "submit_attributes": ['name']
      },
      {
        "form_type": 'registration',
        "form_id": '#customer-form',
        "term_id": '716075d9-4b93-4c07-b2c6-ca2fb1c6675e',
        "classes_add": [
          ['[name="firstname"]', 'mm-prv-name'],
          ['[name="lastname"]', 'mm-prv-surname'],
          ['[name="email"]', 'mm-prv-email'],
          ['[name="birthday"]', 'mm-prv-crp'],
          ['[name="newsletter"]', 'newsletter'],
          ['[name="psgdpr"]', 'dati_personali']
        ],
        "submit": '[type="submit"]',
        "el_to_hide_closest": [
          ['[name="newsletter"]','.form-group'],
          ['[name="psgdpr"]','.form-group'],
          ['[name="optin"]','.form-group']
        ],
        "el_to_wrap": [],
        "wrapper_insert_before": 'footer',
        "submit_attributes": ['data-link-action']
      }
  ]
}
var mm_dataone = {
  init: function () {
    function microtime() {
      /* cache busting */
      let d = new Date();
      let n = d.getTime();
      return n;
    }
    $('.mm-prv-agree-submit').on('click', function () {
      $('.sc_button').trigger('click');
    });
    var lg = $('html').attr('lang');
    $('head').append('<link rel="stylesheet" type="text/css" href="https://static.dataone.online/widget/mmprvwidget.css?d=' + microtime() + '">');
    $('head').append('<link href="https://static.dataone.online/cookiebar/js/cookie.bundle.js" rel="preload" as="script">');
    $('body').append('<div id="mm-cookie-app" data-language="' + lg + '" data-owner="' + mm_dataone_config.owner_id + '"></div><script src="https://static.dataone.online/cookiebar/js/cookie.bundle.js" ></script>');
    var forms = mm_dataone_config.forms;
    var setWidgetWrapper = function (form) {
      /* append dataone wrapper */
      if ($(form.form_id).find(form.el_to_wrap).length> 0) {
        $(form.form_id).find(form.el_to_wrap).wrapAll('<div id="mm-prv-wdg"></div>');
      }
      /* append dataone wrapper */
      if ($(form.form_id).find(form.wrapper_insert_before).length> 0) {
        $('<div id="mm-prv-wdg"></div>').insertBefore($(form.form_id).find(form.wrapper_insert_before));
      }
      
    }
    var setSubmitButton = function (form) {
      $(form.form_id).find(form.submit).addClass('mm-prv-form-submit');
    }
    /* loop array forms */
    $.each(forms, function (index, currentForm) {
      if ($(currentForm.form_id).length> 0) {
        /* main class assign */
        if ($(currentForm.form_id).is("form")) { /* check if element is form */
          $(currentForm.form_id).addClass('mm-prv-form');
        } else {
          $(currentForm.form_id).find('form').addClass('mm-prv-form');
        }
        /* add dataone classes to fields */
        $.each(currentForm.classes_add, function (idx, field) {
          $(currentForm.form_id).find(field[0]).addClass(field[1]);
        });
        /* find submit button and add dataone classes */
        setSubmitButton(currentForm);
        /* elements to remove */
        $.each(currentForm.el_to_remove, function (idx, remove) {
          $(currentForm.form_id).find(remove).remove();
        });
        /* elements to hide */
        $.each(currentForm.el_to_hide, function (idx, el) {
          $(currentForm.form_id).find(el).hide();
        });
        /* elements to hide closest */
        $.each(currentForm.el_to_hide_closest, function (idx, el) {
          $(currentForm.form_id).find(el[0]).closest(el[1]).hide();
        });
        /* add hiddens */
        $.each(currentForm.hidden_add, function (idx, hidden) {
          $('<input type="hidden" name="' + hidden[0] + '" value="' + hidden[1] + '">').insertBefore($('#mm-prv-wdg'));
        });
        setWidgetWrapper(currentForm);
        /* get submit text and classes */
        var submit_text = $(currentForm.form_id).find(currentForm.submit).text();
        if(submit_text===''){
          submit_text = $(currentForm.form_id).find(currentForm.submit).val();
        }
        var submit_classes = $(currentForm.form_id).find(currentForm.submit).attr('class');
        var newString = submit_classes.replace("mm-prv-form-submit","");

        var term_id = currentForm.term_id;
        /* setting */
        window.prwidget = {
          language: $('html').attr('lang'),
          submitCaption: submit_text,
          submitClass: newString,
          submitAttributes: currentForm.submit_attributes,
          ownerId: mm_dataone_config.owner_id,
          termId: term_id
        }
        /* append js widget */
        /* only for woocommerce checkout */
        if (currentForm.form_type == 'checkout') { /* checkout case */
          if ($('[name="account_password"]').length> 0) { /* if is logged */
            $(document).on('updated_checkout', function () {
              /* move wrapper */
              $("#mm-prv-wdg").appendTo(".place-order");
              $('[name="terms"]').addClass('dati_personali');
              $('.place-order p.privacy').first().find('[name="privacy_policy"]').addClass('dati_personali');
              $('.woocommerce-terms-and-conditions-wrapper').hide();
              $('.form-row.privacy').hide();
              /* reassign submit features */
              $(currentForm.form_id).find(currentForm.submit).addClass('mm-prv-form-submit');
              window.prwidget.submitCaption = $(currentForm.form_id).find(currentForm.submit).text();
              /* call widget features */
              $.getScript('https://static.dataone.online/widget/mmprvwidget.js?d=' + microtime());
              return false;
            });
            $(document).delegate('[name="payment_method"]', 'change', function () {
              setWidgetWrapper(currentForm);
              return false;
            });
          }
        } else {
          $.getScript('https://static.dataone.online/widget/mmprvwidget.js?d=' + microtime());
          return false;
        }
      }
    });
  }
}
mm_dataone.init(); 

$(document).delegate('.mm-prv-form-submit','click',function(){
  if( $('#customer-form').length > 0){
    if( $('#customer-form').attr('action').indexOf('b2b') > -1){
      dataLayer.push({'event': 'registrazione_b2b'});
    } else {
      dataLayer.push({'event': 'registrazione_sito'});
    }  
  } 
});


// WEBPACK FOOTER //
// ./js/dataone.js